import { useContext, useEffect, useState } from 'react';
import { CartContext } from '../contexts/CartContext';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { DISPLAY_LANG } from '../config';
import { errorMessage } from '../api/global';
import { useSearchParams } from 'react-router-dom';
import Loading from '../components/loading';
import axios from '../axios';
import '../stylesheets/registerHosting.css';

export default function RegisterHosting() {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const [cursorLoad, setCursorLoad] = useState(false);
  const [input, setInput] = useState('');
  const [showAddToCartBtn, setShowAddToCartBtn] = useState(false);
  const { addHostingToCart } = useContext(CartContext);
  const { plan_name } = useParams();
  const navigate = useNavigate();
  const billing = searchParams.get('billing'); // "monthly" կամ "yearly"

  useEffect(() => {
    const loadingData = async () => {
      const resPageData = await axios.get(`isp/register-hosting?lang=${DISPLAY_LANG}`);
      setPageData(resPageData.data[0]);

      let LAST_REGISTERED_DOMAIN_FOR_HOSTING;

      if (sessionStorage.getItem('LAST_REGISTERED_DOMAIN_FOR_HOSTING')) {
        LAST_REGISTERED_DOMAIN_FOR_HOSTING = JSON.parse(sessionStorage.getItem("LAST_REGISTERED_DOMAIN_FOR_HOSTING"));
        setInput(LAST_REGISTERED_DOMAIN_FOR_HOSTING.domain);
      }

      sessionStorage.removeItem("REDIRECTED_FROM_REGISTER_HOSTING");

      setLoading(false);
    };

    loadingData();
    window.scrollTo(0, 0);
    sessionStorage.removeItem("SELECTED_HOSTING_PLAN_NAME");
  }, [])

  const handlerNewDomainLink = () => {
    if (cursorLoad) return;
    sessionStorage.setItem("REDIRECTED_FROM_REGISTER_HOSTING", `/hosting/${plan_name}?billing=${billing}`);
    navigate('/domain');
  };

  const validateDomain = (domain) => {
    const domainRegex =
      /^(?!-)(?:[a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,}$/;

    if (!domain || domain.trim() === "") {
      return {
        ok: false,
        message: {
          en: "Domain is required",
          ru: "Домен обязателен",
          am: "Դոմեյնը պարտադիր է"
        }
      };
    }

    domain = domain.trim().toLowerCase();

    // 👉 եթե սկսվում է www-ով
    if (domain.startsWith("www.")) {
      return {
        ok: false,
        message: {
          en: "Please enter domain without 'www.' (example: example.com)",
          ru: "Введите домен без 'www.' (пример: example.com)",
          am: "Խնդրում ենք մուտքագրել դոմեյնը առանց 'www.' (օրինակ՝ example.com)"
        }
      };
    }

    // 👉 հիմնական format validation
    if (!domainRegex.test(domain)) {
      return {
        ok: false,
        message: {
          en: "Invalid domain format (example: example.com)",
          ru: "Неверный формат домена (пример: example.com)",
          am: "Դոմեյնի ֆորմատը սխալ է (օրինակ՝ example.com)"
        }
      };
    }

    return { ok: true };
  };

  const handleCheckBtn = async (e) => {
    e.preventDefault();

    if (cursorLoad) return;

    let domain = input.trim().toLowerCase();
    const validation = validateDomain(domain);

    if (!validation.ok) {
      alert(validation.message[DISPLAY_LANG]);
      return;
    }

    setCursorLoad(true);

    const body = {
      domain,
      user_id: localStorage.getItem('user_id'),
    };

    try {
      const res = await axios.post("domain/check-domain-hosting", body);
      if (res.data.ok) {
        setShowAddToCartBtn(true);
      }

      if (!res.data.ok) {
        alert(res.data.message[DISPLAY_LANG]);
      }

    } catch (error) {
      console.log(error);
      alert(errorMessage[DISPLAY_LANG])
    } finally {
      setCursorLoad(false);
    }
  };

  const addHostingToCartHandler = async () => {
    try {
      setCursorLoad(true);
      const SELECTED_HOSTING_PLAN = JSON.parse(sessionStorage.getItem('SELECTED_HOSTING_PLAN'));
      const USER_ID = localStorage.getItem('user_id');

      const body = {
        "cart": USER_ID,
        "item_type": "hosting",
        "isp_hosting_name": SELECTED_HOSTING_PLAN.name,
        "isp_hosting_connected": input,
        "isp_hosting_billing_type": billing,
        "isp_hosting_price": SELECTED_HOSTING_PLAN.prices,
      };

      await addHostingToCart(body);
      navigate('/user/cart');
    } catch (error) {
      console.error(error);
      setCursorLoad(false);
      alert(errorMessage[DISPLAY_LANG]);
    }
  };

  if (loading) {
    return <Loading />
  }

  return (
    <div className="RegisterHosting wrapper" style={{ cursor: cursorLoad ? 'wait' : '' }}>
      <h1 className='registerHostingHeading'>{pageData.title} - {plan_name}</h1>

      <p
        className='registerHostingNewDomainLink'
        onClick={handlerNewDomainLink}
        style={{ cursor: cursorLoad ? 'wait' : '' }}
      >
        {pageData.new_domain_link_text}
      </p>

      <form onSubmit={handleCheckBtn} className="registerHosingExistingDomainBox">
        <p>{pageData.existing_domain_text}</p>

        <div>www.</div>
        <input
          type="text"
          onChange={e => setInput(e.target.value)}
          style={{ cursor: cursorLoad ? 'wait' : '' }}
          value={input}
        />

        <button
          className='btn'
          style={{ cursor: cursorLoad ? 'wait' : '' }}
          onClick={handleCheckBtn} type='submit'
        >
          {pageData.btn_text}
        </button>
      </form>

      {showAddToCartBtn && <button
        style={{ cursor: cursorLoad ? 'wait' : '' }}
        className='add-to-cart btn' onClick={addHostingToCartHandler}
      >
        {pageData.add_to_cart_btn}
      </button>}
    </div>
  )
}
